import { AudioPlayer } from 'kuaidong-lib'
import { IAiTeacherProfile, IAiTeacherVoice } from 'kuaidong-model'
export interface IAiTeacherVoiceWithAudio extends IAiTeacherVoice {
  audio: AudioPlayer
}

export class AiTeacherAudioPlayer {
  audioMap: Record<string, AudioPlayer> = {}
  canplay = true
  curPlayer: AudioPlayer = new AudioPlayer('')
  // curPlayList: Array<AudioPlayer> = []
  si_WordDisplay: any = null
  st_TimeTick: any = null
  recordMap: Record<string, Array<IAiTeacherVoice>> = {}
  profiles: IAiTeacherProfile[] = []

  constructor(profiles: IAiTeacherProfile[], preload?: boolean) {
    this.profiles = profiles || []
    if (profiles && profiles.length) {
      for (let i = 0; i < profiles.length; i++) {
        const profile = profiles[i]
        this.recordMap[profile.id] = profile.records
        if ((profile.records || [])[0]?.voice_url && preload) {
          this.audioMap[profile.id] = new AudioPlayer(profile.records[0].voice_url)
        }
      }
      this.curPlayer = this.audioMap[profiles[0].id || ''] || this.curPlayer
    }
  }

  public async play(id: string, callback: (cur: string) => void, interval?: number) {
    if (id && this.recordMap[id] && this.recordMap[id].length) {
      this.pause()
      this.canplay = true
      const list = this.recordMap[id] || []
      this.curPlayer = this.audioMap[id] ? this.audioMap[id] : new AudioPlayer(list[0]?.voice_url || '')
      for (let i = 0; i < list.length; i++) {
        if (this.curPlayer.getSrc() !== list[i].voice_url) {
          this.curPlayer.setSrc(list[i].voice_url)
        }
        if (this.canplay) {
          // 播放过程中，处理文字逐字展示
          if (this.si_WordDisplay) {
            clearInterval(this.si_WordDisplay)
          }
          this.si_WordDisplay = setInterval(() => {
            if (
              this.curPlayer.audio.currentTime &&
              this.curPlayer.audio.duration &&
              Number.isFinite(this.curPlayer?.audio?.duration) &&
              list[i].text
            ) {
              // 计算当前播放时间占总时间的比例，进度多推进0.3秒
              const duration = this.curPlayer.audio.duration * 1000
              const sumDuration = duration > 300 ? duration - 300 : duration
              const len = ((this.curPlayer.audio.currentTime * 1000) / sumDuration) * list[i].text.length
              const curtext = (list[i].text || '').slice(
                0,
                Math.floor(len > list[i].text.length ? list[i].text.length : len)
              )
              callback(curtext || '')
              if (len >= list[i].text.length) {
                clearInterval(this.si_WordDisplay)
              }
            }
          }, 100)
          // 播放
          await this.curPlayer.play()
          await this.curPlayer.pause()
          // 处理下一个音频逻辑
          if (list[i + 1] && list[i + 1].voice_url) {
            this.curPlayer.setSrc(list[i + 1].voice_url)
          }
          if (this.si_WordDisplay) {
            clearInterval(this.si_WordDisplay)
          }
          // 如果设置了播放间隔，则进行延迟
          if (interval) {
            await this.timeTick(interval || 1500)
          }
        }
      }
      // 播放完成，清除环境
      this.pause()
    }
  }
  public pause() {
    this.curPlayer.pause()
    // 如果是延时播放，则需清除定时器，避免当前播放器被替换为定时任务中的下一个播放器
    if (this.st_TimeTick) {
      clearTimeout(this.st_TimeTick)
    }
    if (this.si_WordDisplay) {
      clearInterval(this.si_WordDisplay)
    }
    this.canplay = false
  }
  public setCanPlay(canPlay: boolean) {
    this.canplay = canPlay
  }

  async timeTick(num: number) {
    return new Promise((resolve) => {
      clearTimeout(this.st_TimeTick)
      this.st_TimeTick = setTimeout(() => {
        clearTimeout(this.st_TimeTick)
        resolve(num)
      }, num)
    })
  }
}
